import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { connect } from 'react-redux';
import { toggleAllShades } from '../modules';

const ProductInfoContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...props} />
);

const mapStateToProps = ({
  productInfo = {},
  breakpoints = {},
  productSwatch,
  content,
}) => ({
  isOpen: productInfo.isOpen,
  currentBreakpoint: R.prop('current')(breakpoints),
  selectedSKU: R.prop('selectedSKU')(productSwatch),
  channelAdvisorWidget: R.prop('channelAdvisorWidget', content),
  mikMakConfig: R.prop('mikmak', content),
});

const mapDispatchToProps = (dispatch) => ({
  toggleAllShades: () => dispatch(toggleAllShades()),
});

ProductInfoContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductInfoContainer);
